export default __webpack_public_path__ + "static/media/external.c61d433f.svg";